import React from "react";
import { useTranslation } from "react-i18next";
import { BRAND_COLORS, SEMANTIC_COLORS } from "./constants";

const OverallScore = ({ queryScores }) => {
  const { t } = useTranslation();
  const overallOriginal = Math.round((queryScores[0]?.oldScore || 0) * 100);
  const overallCurrent = Math.round((queryScores[0]?.newScore || 0) * 100);
  const overallDelta = overallCurrent - overallOriginal;
  const isIncrease = overallCurrent > overallOriginal;
  const deltaWidth = Math.abs(overallDelta);

  return (
    <div
      className="bg-white card-radius p-4 border mb-4"
      style={{ borderColor: `${BRAND_COLORS.success}` }}
      data-testid="overall-score"
    >
      <p
        className="fw-semibold text-uppercase mb-2"
        style={{
          fontSize: "0.84rem",
          letterSpacing: "0.08em",
          color: "var(--text-secondary)",
        }}
      >
        {t("contentOptimizer.overallScore", "Overall Retrievability Score")}
      </p>
      <div className="d-flex align-items-center gap-3">
        <div className="fs-1 fw-bold" style={{ color: BRAND_COLORS.success }}>
          {overallCurrent}
        </div>
        <div className="flex-fill">
          <div
            className="position-relative rounded-pill overflow-hidden mb-2"
            style={{
              height: "12px",
              backgroundColor: SEMANTIC_COLORS.barTrack,
            }}
          >
            {isIncrease ? (
              <>
                {/* Base portion up to original (brand primary with opacity) */}
                <div
                  className="position-absolute top-0 start-0 h-100 rounded-pill"
                  style={{
                    width: `${overallOriginal}%`,
                    backgroundColor: `${BRAND_COLORS.primary}B3`, // 70% opacity
                  }}
                />
                {/* Delta segment (dark green) */}
                <div
                  className="position-absolute top-0 h-100 rounded-end-pill"
                  style={{
                    left: `${overallOriginal}%`,
                    width: `${deltaWidth}%`,
                    backgroundColor: SEMANTIC_COLORS.successDark,
                  }}
                />
              </>
            ) : (
              <>
                {/* Base portion up to current (brand primary with opacity) */}
                <div
                  className="position-absolute top-0 start-0 h-100 rounded-pill"
                  style={{
                    width: `${overallCurrent}%`,
                    backgroundColor: `${BRAND_COLORS.primary}B3`, // 70% opacity
                  }}
                />
                {/* Delta segment (red) */}
                <div
                  className="position-absolute top-0 h-100 rounded-end-pill"
                  style={{
                    left: `${overallCurrent}%`,
                    width: `${deltaWidth}%`,
                    backgroundColor: SEMANTIC_COLORS.errorDark,
                  }}
                />
              </>
            )}
          </div>
          <p
            className="mb-1"
            style={{ fontSize: "0.96rem", color: "var(--text-muted)" }}
          >
            <span style={{ color: "var(--text-secondary)" }}>
              {t("contentOptimizer.original", "Original")}:
            </span>{" "}
            <span
              className="fw-semibold"
              style={{ color: "var(--text-primary)" }}
            >
              {overallOriginal}
            </span>{" "}
            &nbsp;·&nbsp;{" "}
            <span style={{ color: "var(--text-secondary)" }}>
              {t("contentOptimizer.current", "Current")}:
            </span>{" "}
            <span
              className="fw-semibold"
              style={{ color: "var(--text-primary)" }}
            >
              {overallCurrent}
            </span>{" "}
            &nbsp;·&nbsp;{" "}
            <span style={{ color: "var(--text-secondary)" }}>
              {t("dashboard.change", "Change")}:
            </span>{" "}
            <span
              className="fw-semibold"
              style={{
                color:
                  overallDelta > 0
                    ? "var(--success-dark)"
                    : overallDelta < 0
                      ? "var(--error-dark)"
                      : "var(--text-secondary)",
              }}
            >
              {overallDelta > 0 ? "+" : ""}
              {overallDelta}
            </span>
          </p>
          <p
            className="mt-2 mb-0 d-flex align-items-center gap-1"
            style={{ fontSize: "0.86rem", color: "var(--text-muted)" }}
          >
            <span>{t("contentOptimizer.legend", "Legend:")}</span>
            <span
              className="d-inline-block rounded"
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: `${BRAND_COLORS.primary}B3`,
                flexShrink: 0,
              }}
            />
            <span>{t("contentOptimizer.original", "original")}</span>
            <span
              className="d-inline-block rounded ms-1"
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: SEMANTIC_COLORS.successDark,
                flexShrink: 0,
              }}
            />
            <span>{t("contentOptimizer.improvement", "improvement")}</span>
            <span
              className="d-inline-block rounded ms-1"
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: SEMANTIC_COLORS.errorDark,
                flexShrink: 0,
              }}
            />
            <span>{t("contentOptimizer.decreaseVsOriginal", "decrease vs original")}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default OverallScore;
